import { AutoMap } from "@automapper/classes";

export class Competence {
    @AutoMap()
    Name!: string;

    static mapFromJSON(json): Competence {
        const cm = new Competence;

        cm.Name = json['name'];
        return cm;
    }
}